<div class="fieldset-wrapper ratingScaleQtype" [ngClass]="
    (questions?.mandatory && isMandatoryUpfront) ||
    (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)
      ? 'isMandatory'
      : ''
  ">
  <span *ngIf="(questions?.mandatory && isMandatoryUpfront) ||
    (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)" class="screen-read-only">This Question is
    Required</span>
  <div *ngIf="questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset [attr.aria-required]="isAriaRequired">
    <legend class="question-option-wrapper question-rs-wrapper"
      [ngClass]="{ 'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile }">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)"
        class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false"
        IsAnswerToolTip="true" IsHiddenQToolTip="true">
      </span>
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{ questions?.qno }}.</strong></span>
      <span *ngIf="questions.piping" [ngClass]="{
          'question-text': questions?.isOverAllStyleApplied,
          'question-text-nb': !questions?.isOverAllStyleApplied,
          'no-Qno': !isDisplayQno
        }" id="lbltitle_RS{{ questions?.UniqueNumber }}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
        <span class="imgPostPrepop"
          *ngIf="isEditPostPop == true && (questions.population_type== 4 || questions.population_type == 5)"></span>
      </span>
      <span *ngIf="!questions.piping" [ngClass]="{
          'question-text': questions?.isOverAllStyleApplied,
          'question-text-nb': !questions?.isOverAllStyleApplied,
          'no-Qno': !isDisplayQno
        }" id="lbltitle_RS{{ questions?.UniqueNumber }}">
        <span *ngIf="isDisplaySubQno" style="display: inline-block"
          [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
        <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
        <span class="imgPostPrepop"
          *ngIf="isEditPostPop == true && (questions.population_type== 4 || questions.population_type == 5)"></span>
        <div *ngIf="questions?.hasMedia && questions?.MediaText != null && questions?.MediaText != ''"
          class="question-media-text">
          <span>[{{ questions?.MediaText }}]</span>
        </div>
      </span>
      <span *ngIf="isAriaRequired && isMobile" class="screen-reader-only">This Question is Required</span>
    </legend>

    <div *ngIf="questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <div class="fieldset-wrapper-scroll-cont">
      <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
      <div class="fieldset-wrapper-scroll rs-wrapper-scroll" [ngStyle]="{
          'overflow-y':
            (questions?.RS_Type == 3 || questions?.RS_Type == 4 || questions?.RS_Type == 2) &&
            isMobile
              ? ''
              : 'hidden',
          'overflow-x': isMobile ? 'hidden' : 'auto'
        }">
        <div style="display: table; width: 100%" class="answerParent">
          <div
            [ngClass]="{ 'answer-option-wrapper': true, 'nps-box': questions?.RS_Type == 2, 'disabled-ratingScale-qtype': questions?.IsDisabled }">
            <!-- NPS -->
            <div *ngIf="questions?.RSFormat == 3">
              <div class="nps-wrapper clearfix" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }" role="radiogroup">
                <div class="nps-ans-option palette-{{questions?.PaletteID}}" [ngClass]="{'nps-ans-option-first': k==0, 
                'nps-ans-option-last': k==questions?.Answers.length - 1,
                'palette':questions?.PaletteID > 0}" [attr.data-state]="'N_'+k"
                  *ngFor="let item of questions?.Answers; let k = index">
                  <input type="radio" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                    [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                    id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                    value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                    (change)="SelectedValue(item, $event.target.checked);selectUnSelectNPS($event.target);nextQuestion($event.target)"
                    [attr.aria-label]="item.weight" />
                  <label for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                    (click)="unselectNps($event.target, $event)" [attr.aria-hidden]="true">{{item.weight}}
                  </label>


                </div>
              </div>
              <div class="nps-axis-text-wrapper">
                <ng-container *ngIf="!isMobile;else Mobileaxistext">
                  <div class="nps-axis-text"
                    [ngClass]="{'nps-axis-text-first': k==0, 'nps-axis-text-last': k==questions?.Answers.length - 1}"
                    *ngFor="let item of questions.Answers; let k = index">{{item.value_text}}</div>
                </ng-container>
                <ng-template #Mobileaxistext>
                  <div class="nps-axis-text"
                    [ngClass]="{'nps-axis-text-first': k==0, 'nps-axis-text-last': k==questions?.Answers.length - 1}"
                    *ngFor="let item of questions.Answers; let k = index">
                    <ng-container *ngIf="item.value_text!='';else blankMobileaxistext">
                      {{item.value_text}}
                    </ng-container>
                    <ng-template #blankMobileaxistext>
                      {{item.value_text}}
                    </ng-template>
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- CSAT CES -->
            <div *ngIf="questions?.RSFormat == 2"
              [ngClass]="{'csat': questions?.RS_Type == 4,
              'ces': questions?.RS_Type == 3 || (questions?.RS_Type == 0 && questions?.RSFormat == 2),
              'setOf11': ((isNAEnable() &&  questions?.Answers.length -1 === 11)|| (isNAEnable() ==false &&  questions?.Answers.length === 11)) && questions?.RS_Type == 0 && questions?.RSFormat == 2,
              'setOf10': ((isNAEnable() &&  questions?.Answers.length -1 === 10)||(isNAEnable() ==false &&  questions?.Answers.length === 10)) && questions?.RS_Type == 0 && questions?.RSFormat == 2,
              'setOf7': ((isNAEnable() &&  questions?.Answers.length -1 === 7)||(isNAEnable() ==false &&  questions?.Answers.length === 7)) && questions?.RS_Type == 0 && questions?.RSFormat == 2,
              'setOf5': ((isNAEnable() &&  questions?.Answers.length -1 === 5)||(isNAEnable() ==false &&  questions?.Answers.length === 5)) && questions?.RS_Type == 0 && questions?.RSFormat == 2,
              'setOf3': ((isNAEnable() &&  questions?.Answers.length -1 === 3)||(isNAEnable() ==false &&  questions?.Answers.length === 3)) && questions?.RS_Type == 0 && questions?.RSFormat == 2}">
              <div class="ces-csat-wrapper clearfix" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }">
                <div class="ces-csat-ans-option"
                  [ngClass]="(i==0 || i==questions?.Answers.length-1) && questions.AnswerID!=0 ? 'firstlast-ces-csat-ans-option' : (i!=0 && i!=questions?.Answers.length-1)&&questions.AnswerID==0?'notfirstlast-ces-csat-ans-option':''"
                  *ngFor="let item of GetAnswers(); let i = index">
                  <input type="radio" role="radio" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                    [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                    id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                    value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                    (change)="SelectedValue(item, $event.target.checked);nextQuestion($event.target)"
                    [attr.aria-label]="item.value_text" />
                  <label (click)="unselectCesCsat($event.target, $event)"
                    *ngIf="!isRTL && !questions.isAnchorReverse || isRTL && !questions.isAnchorReverse"
                    for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                    class="smiley smiley-{{i+1}} palette-{{questions?.PaletteID}}"
                    [ngClass]="{'palette':questions?.PaletteID >0,'smileyUnSelected':questions?.AnswerID > 0 && item.selectdId == 0}">
                    <ng-container *ngIf="isMobile && (i==0 || i==GetAnswers().length-1);else Otherthanfirstlast">
                      <span class="ces-csat-smiley-text"></span>
                    </ng-container>
                    <ng-template #Otherthanfirstlast>
                      <span class="ces-csat-smiley-text"
                        title="{{getCESCSATSmileyText( GetAnswers(),i)}}">{{getCESCSATSmileyText(
                        GetAnswers(),i)}}</span>
                    </ng-template>
                  </label>
                  <label (click)="unselectCesCsat($event.target)"
                    *ngIf="!isRTL && questions.isAnchorReverse || isRTL && questions.isAnchorReverse"
                    for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                    class="smiley smiley-{{ GetAnswers().length - i}}  palette-{{questions?.PaletteID}}"
                    [ngClass]="{'palette':questions?.PaletteID >0,'smileyUnSelected':questions?.AnswerID > 0 && item.selectdId == 0}">
                    <ng-container *ngIf="isMobile && (i==0 || i==GetAnswers().length-1);else Otherthanfirstlast">
                      <span class="ces-csat-smiley-text"></span>
                    </ng-container>
                    <ng-template #Otherthanfirstlast>
                      <span class="ces-csat-smiley-text"
                        title="{{getCESCSATSmileyText( GetAnswers(),i)}}">{{getCESCSATSmileyText(
                        GetAnswers(),i)}}</span>
                    </ng-template>
                  </label>
                </div>
                <div class="ces-csat-ans-option" *ngIf="questions?.RS_Type == 4 && !isMobile"></div>
                <div class="ces-csat-ans-option" *ngIf="questions?.RS_Type == 4 && !isMobile"></div>
              </div>
              <div
                *ngIf="isMobile && (questions.AnswerID==0||questions.selectAnsValue==1||questions.selectAnsValue== GetAnswers().length)"
                class="csat-default-txt-wrapper">
                <div class="csat-default-txt"
                  [ngClass]="((!isRTL && questions.isAnchorReverse)&&questions.selectAnsValue== GetAnswers().length)||
                ((!isRTL && !questions.isAnchorReverse || isRTL && !questions.isAnchorReverse)&&questions.selectAnsValue==1)||
                (isRTL && questions.isAnchorReverse && questions.selectAnsValue== GetAnswers().length)?'selected-csat-default-txt':''">
                  <ng-container
                    *ngIf="(questions.AnswerID==0 &&((!isRTL && !questions.isAnchorReverse)||(isRTL && !questions.isAnchorReverse)||(!isRTL && questions.isAnchorReverse)))||
                  ((!isRTL && questions.isAnchorReverse)&&questions.selectAnsValue== GetAnswers().length)||
                  ((!isRTL && !questions.isAnchorReverse || isRTL && !questions.isAnchorReverse) && questions.selectAnsValue==1)">
                    {{ getCESCSATSmileyText( GetAnswers(),0) }}
                  </ng-container>
                  <ng-container *ngIf="(questions.AnswerID==0 &&isRTL && questions.isAnchorReverse)
                  ||(isRTL && questions.isAnchorReverse&&questions.selectAnsValue== GetAnswers().length)">
                    {{ getCESCSATSmileyText( GetAnswers(),0)}}

                  </ng-container>
                </div>
                <div class="csat-default-txt" [ngClass]="((!isRTL && questions.isAnchorReverse)&&questions.selectAnsValue==1)||
                ((!isRTL && !questions.isAnchorReverse || isRTL && !questions.isAnchorReverse) &&questions.selectAnsValue== GetAnswers().length)||
                (isRTL && questions.isAnchorReverse && questions.selectAnsValue == 1)?'selected-csat-default-txt':''">
                  <ng-container
                    *ngIf="(questions.AnswerID==0 &&((!isRTL && !questions.isAnchorReverse)||(!isRTL && questions.isAnchorReverse)||(isRTL && !questions.isAnchorReverse)))
                  ||((!isRTL && questions.isAnchorReverse) && questions.selectAnsValue==1)||
                  ((!isRTL && !questions.isAnchorReverse || isRTL && !questions.isAnchorReverse)&&questions.selectAnsValue== GetAnswers().length)">
                    {{getCESCSATSmileyText( GetAnswers(),GetAnswers().length - 1)}}
                  </ng-container>
                  <ng-container *ngIf="(questions.AnswerID==0 &&isRTL && questions.isAnchorReverse)
                  ||(isRTL && questions.isAnchorReverse&&questions.selectAnsValue==1)">
                    {{getCESCSATSmileyText( GetAnswers(),GetAnswers().length - 1)}}

                  </ng-container>
                </div>
              </div>
              <div *ngIf="isMobile && questions.Answers[questions.Answers.length - 1].isNA" class="na-checkbox">
                <input type="checkbox" id="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID"
                  [(ngModel)]="questions.isNA" value="questions.UniqueNumber"
                  (change)="disableEnableSmiley($event.target, $event.target.checked, questions.Answers[questions.Answers.length - 1], $event)" />
                <label for="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID">
                  <span class="check-btn structure"></span>
                  <span
                    [innerHTML]="(questions.Answers[questions.Answers.length - 1].value_text ? questions.Answers[questions.Answers.length - 1].value_text : 'N/A' )  | headerFooterHtml"
                    class="answer-text"></span>
                </label>
              </div>
            </div>

            <!-- Rating Scale -->
            <div class="rating-scale-cont" *ngIf="questions?.RSFormat == 0 && !isMobile">
              <div class="rs-wrapper" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }">

                <div>
                  <div class="rs-slider" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS">
                    <div class="rs-slider-axis-wrapper"
                      [attr.isna]="questions.Answers[questions.Answers.length - 1].isNA"
                      [attr.isrev]="questions.isAnchorReverse">
                      <label class="rs-slider-axis-val" role="radiogroup" *ngFor="let item of questions.Answers"
                        [attr.weight]="item.value_id"
                        for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID">
                        {{item.weight}}
                        <input type="radio" role="radio" [attr.weight]="item.weight"
                          id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                          name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                          [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                          value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                          (click)="SelectedValue(item, $event.target.checked)" [attr.aria-hidden]="true"
                          tabindex="-1" />
                        <span class="slider-value-text">
                          <span title="{{item.value_text}}">{{item.value_text}}</span>
                        </span>
                      </label>
                    </div>
                  </div>

                  <div *ngIf="questions.Answers[questions.Answers.length - 1].isNA" class="na-checkbox">
                    <input type="checkbox" id="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID"
                      [(ngModel)]="questions.isNA" value="questions.UniqueNumber"
                      (change)="disableEnableSlider($event.target, $event.target.checked, questions.Answers[questions.Answers.length - 1], $event)" />
                    <label for="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID">
                      <span class="check-btn structure"></span>
                      <span
                        [innerHTML]="( questions.Answers[questions.Answers.length - 1].value_text ? questions.Answers[questions.Answers.length - 1].value_text : 'N/A' )  | headerFooterHtml"
                        class="answer-text"></span>
                    </label>
                  </div>
                </div>
                <ng-template #Textpopulation>
                  <span class="answer-text">{{GetQuestionPrePopValue()}}</span>
                </ng-template>
              </div>
              <div class="rs-clear-cont" [ngClass]="{'hide-clear-box': !isShowClear}">
                <input (keypress)="numberOnly($event)" type="number" class="rs-clear-inp" (input)="setRsScale($event)"
                  aria-label="Input for Slider" min={{sliderMinValue}} max={{sliderMaxValue}}
                  [ngClass]="{'red-zone':questions.isValid}" (keydown.enter)="stopEnter($event);" />
                <div class="rs-clear-text-cont">
                  <span class="rs-clear-text" (keydown.space)="clearRatingScale($event)"
                    (click)="clearRatingScale($event)" tabindex="0" role="button"
                    aria-label="Clear Slider">{{clearText}}</span>
                </div>
                <div *ngIf="questions.isValid" class="rating-scale validator_message" role="alert">
                  {{questions.ClearOptionErrorMsg}}
                </div>
              </div>
            </div>

            <!-- Rating Scale Mobile -->
            <div class="rs-mobile-cont" *ngIf="questions?.RSFormat == 0 && isMobile">
              <div class="rs-mobile-wrapper" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }">
                <div>
                  <div class="rs-overlay"></div>
                  <div class="rs-slider" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS">
                    <div class="rs-slider-axis-wrapper"
                      [attr.isna]="questions.Answers[questions.Answers.length - 1].isNA"
                      [attr.isrev]="questions.isAnchorReverse">
                      <label class="rs-slider-axis-val" *ngFor="let item of questions.Answers"
                        [attr.weight]="item.value_id"
                        for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID">
                        <span class="rs-weight">{{item.weight}}</span>
                        <input type="radio" role="radio" [attr.weight]="item.weight"
                          id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                          name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                          [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                          value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                          (click)="SelectedValue(item, $event.target.checked)" aria-label="textbox"
                          [ngClass]="{'red-zone':questions.isValid}" />
                        <ng-container *ngIf="questions.group_no == 0; else gridHeader">
                          <span class="slider-value-text" title="{{item.value_text}}"
                            *ngIf="item.value_text != ''"><span class="slider-value-text-span"
                              title="{{item.value_text}}">{{item.value_text}}</span></span>
                        </ng-container>
                        <ng-template #gridHeader>
                          <span class="slider-value-text" title="{{item.value_text}}"
                            *ngIf="item.value_text != ''"><span class="slider-value-text-span"
                              title="{{item.value_text}}">{{RatingScaleHeaderText(questions,1,item)}}</span></span>
                        </ng-template>
                        <span class="slider-value-text" *ngIf="item.value_text == ''">{{item.weight}}</span>
                      </label>
                    </div>
                  </div>

                  <div class="rs-end-values-cont">
                    <div class="rs-end-values clearfix">
                      <div class="rs-low-value fl">
                        <span *ngIf="questions.Answers[0].value_text == ''" title="{{questions.Answers[0].weight}}">
                          {{questions.Answers[0].weight}}</span>
                        <ng-container *ngIf="questions.group_no == 0; else gridHeader">
                          <span *ngIf="questions.Answers[0].value_text != ''"
                            title="{{questions.Answers[0].value_text}}">
                            {{questions.Answers[0].value_text}}</span>
                        </ng-container>
                        <ng-template #gridHeader>
                          <span *ngIf="questions.Answers[0].value_text != ''"
                            title="{{questions.Answers[0].value_text}}">
                            {{RatingScaleHeaderText(questions,1,questions.Answers[0])}}</span>
                        </ng-template>

                      </div>
                      <div class="rs-high-value fr"
                        title="{{questions.Answers[questions.Answers.length - 1].value_text}}"
                        *ngIf="!questions.Answers[questions.Answers.length - 1].isNA">
                        <span *ngIf="questions.Answers[questions.Answers.length - 1].value_text == ''"
                          title="{{questions.Answers[questions.Answers.length - 1].weight}}">
                          {{questions.Answers[questions.Answers.length - 1].weight}}</span>
                        <ng-container *ngIf="questions.group_no == 0; else gridHeader">
                          <span *ngIf="questions.Answers[questions.Answers.length - 1].value_text != ''">
                            {{questions.Answers[questions.Answers.length - 1].value_text}}</span>
                        </ng-container>
                        <ng-template #gridHeader>
                          <span *ngIf="questions.Answers[questions.Answers.length - 1].value_text != ''">
                            {{RatingScaleHeaderText(questions,1,questions.Answers[questions.Answers.length -
                            1])}}</span>
                        </ng-template>

                      </div>
                      <div class="rs-high-value fr"
                        title="{{questions.Answers[questions.Answers.length - 2].value_text}}"
                        *ngIf="questions.Answers[questions.Answers.length - 1].isNA">
                        {{questions.Answers[questions.Answers.length - 2].weight}}
                        <ng-container *ngIf="questions.group_no == 0; else gridHeader">
                          <span *ngIf="questions.Answers[questions.Answers.length - 2].value_text != ''">
                            {{questions.Answers[questions.Answers.length - 2].value_text}}</span>
                        </ng-container>
                        <ng-template #gridHeader>
                          <span *ngIf="questions.Answers[questions.Answers.length - 2].value_text != ''">
                            {{RatingScaleHeaderText(questions,1,questions.Answers[questions.Answers.length -
                            2])}}</span>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="questions.Answers[questions.Answers.length - 1].isNA" class="na-checkbox">
                    <input type="checkbox" id="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID"
                      [(ngModel)]="questions.isNA" value="questions.UniqueNumber"
                      (change)="disableEnableSlider($event.target, $event.target.checked, questions.Answers[questions.Answers.length - 1], $event)"
                      aria-label="textbox" />
                    <label style="padding: 0 !important; margin: 0 !important;"
                      for="chk_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NA_ID">
                      <span class="check-btn structure"></span>
                      <span
                        [innerHTML]="( questions.Answers[questions.Answers.length - 1].value_text ? questions.Answers[questions.Answers.length - 1].value_text : 'N/A' ) | headerFooterHtml"
                        class="answer-text answer-text-na"></span>
                    </label>
                  </div>

                  <div id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_Clear_Button" class="clearfix sl_wrapper"
                    [ngStyle]="{'cursor': !isShowClear && questions.selectAnsValue > 0 ? 'pointer' : ''}"
                    (click)="!isShowClear ? clearMobileRatingScale($event) : ''"
                    (keydown.space)="!isShowClear ? clearMobileRatingScale($event) : ''">

                    <div class="sl_input" *ngIf="isShowClear">
                      <input (keypress)="numberOnly($event)" type="number" class="rs-clear-inp"
                        (input)="setRsScale($event)" aria-label="Input for Slider" min={{sliderMinValue}}
                        max={{sliderMaxValue}} id="TB_Scale_{{questions?.UniqueNumber}}_ID"
                        placeholder={{getPlaceHolderValue()}} />

                      <div class="sl_DD_Icon" id="openScale_{{questions?.UniqueNumber}}_ID" #toggleButton
                        [ngClass]="{'active': isMobileRatingScale}" (click)="ddValueChange($event)" role="button"
                        tabindex="0" (keydown.space)="ddValueChange($event)">
                      </div>
                      <div id="changeScale_{{questions?.UniqueNumber}}_ID" #toggleMenu class="o-menu-list"
                        (keydown.esc)="hideDD();">

                        <div
                          *ngFor="let item of ((isRTL && questions.isAnchorReverse) || (isRTL && !questions.isAnchorReverse)) ? ansSort : questions.Answers">
                          <div *ngIf="!item.isNA" id="{{item.value_id}}_{{questions?.UniqueNumber}}"
                            class="o-menu-list-item" (keydown.space)="setRSValue($event, item)"
                            (click)="setRSValue($event, item)"
                            [ngClass]="{'changeStyledropdownActive': item.value_id == questions.selectAnsValue}">
                            <span role="option" class="o-menu-list-item-weight" tabindex="0">{{item.weight}}
                              <span *ngIf="item.value_text" class="o-menu-list-item-text">- {{item.value_text}}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="rs-clear-cont" [ngClass]="{'fr': (isShowClear), 'inline_Btn': !isShowClear}">
                      <div *ngIf="questions.isValid" class="rating-scale-mobile validator_message" role="alert">
                        {{questions.ClearOptionErrorMsg}}
                      </div>
                      <div class="rs-clear-text-cont">
                        <span class="rs-clear-text" role="button" tabindex="0"
                          (keydown.space)="clearMobileRatingScale($event)"
                          (click)="clearMobileRatingScale($event)">{{clearText}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #Textpopulation>
                  <span class="answer-text">{{GetQuestionPrePopValue()}}</span>
                </ng-template>
              </div>
            </div>

            <!-- Smiley Rating Scale -->
            <div class="rating-scale-cont rating-smiley-cont" *ngIf="questions?.RSFormat == 1 && !isMobile">
              <div class="rs-wrapper rs-smiley-wrapper" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }"
                [attr.isrev]="questions.isAnchorReverse">
                <div>
                  <div class="smiley-rs-icon palette-{{questions?.PaletteID}}"
                    [ngClass]="{'palette':questions?.PaletteID > 0}">
                  </div>
                  <div class="smiley-seperator"></div>
                  <div class="rs-smiley-parent">
                    <div class="rs-smiley-slider" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_Smiley">
                      <div class="rs-slider-axis-wrapper" [attr.isrev]="questions.isAnchorReverse">
                        <label class="rs-slider-axis-val" *ngFor="let item of questions.Answers"
                          [attr.weight]="item.weight"
                          for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID">
                          <span class="slider-value-text">
                            <span title="{{getValueText(questions,item)}}">{{getValueText(questions,item)}}</span>
                          </span>
                          <input type="radio" role="radio" role="radio" [attr.state]="getQuestionState(questions)"
                            [attr.weight]="item.weight" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                            [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                            value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                            id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                            (click)="SelectedValue(item, $event.target.checked)" [attr.aria-hidden]="true"
                            tabindex="-1" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #smileyTextpopulation>
                  <span class="answer-text">{{GetQuestionPrePopValue()}}</span>
                </ng-template>
              </div>
              <div class="rs-clear-cont">
                <div class="rs-clear-text-cont">
                  <span class="rs-clear-text" (keydown.space)="clearSmileyRating($event)"
                    (click)="clearSmileyRating($event)" tabindex="0" role="button"
                    aria-label="Clear Slider">{{clearText}}</span>
                </div>
              </div>
            </div>

            <!-- Smiley Rating Scale Mobile -->
            <div class="rs-mobile-cont" *ngIf="questions?.RSFormat == 1 && isMobile">
              <div class="rs-mobile-wrapper" [ngClass]="{'read-only': questions?.population_type == 3}"
                [ngStyle]="{'pointer-events': questions?.population_type == 3? 'none':'' }">
                <div class="rs-overlay"></div>
                <div class="rs-slider" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS">
                  <div class="rs-slider-axis-wrapper" [attr.isna]="questions.Answers[questions.Answers.length - 1].isNA"
                    [attr.isrev]="questions.isAnchorReverse">
                    <label class="rs-slider-axis-val" *ngFor="let item of questions.Answers; let j = index"
                      [attr.weight]="item.weight"
                      for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID">
                      <span class="rs-weight">{{item.weight}}</span>
                      <input type="radio" role="radio" [attr.weight]="item.weight"
                        id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_{{item?.value_id}}_ID"
                        name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RS_NAME"
                        [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_RS_NAME'"
                        value="{{item.value_id}}" [(ngModel)]="item.ControlAns"
                        (click)="SelectedValue(item, $event.target.checked)" aria-label="textbox" />
                      <span
                        class="rs-smiley-cont {{smileyClass[j]}} weight_{{item.weight}}   palette-{{questions?.PaletteID}}"
                        [ngClass]="{'palette':questions?.PaletteID >0}"></span>
                      <span class="slider-value-text" title="{{item.value_text}}" *ngIf="item.value_text != ''"><span
                          class="slider-value-text-span"
                          title="{{getValueText(questions,item)}}">{{getValueText(questions,item)}}</span></span>
                      <span class="slider-value-text" *ngIf="item.value_text == ''">{{item.weight}}</span>
                    </label>
                  </div>
                </div>

                <div class="rs-end-values-cont">
                  <div class="rs-end-values clearfix">
                    <div class="rs-low-value fl">

                      <span *ngIf="questions.Answers[0].value_text == ''" title="{{questions.Answers[0].weight}}">
                        {{questions.Answers[0].weight}} </span>

                      <span title="{{questions.Answers[0].value_text}}" *ngIf="questions.Answers[0].value_text != ''">
                        {{questions.Answers[0].value_text}}</span>
                    </div>
                    <div class="rs-high-value fr" title="{{questions.Answers[questions.Answers.length - 1].value_text}}"
                      *ngIf="!questions.Answers[questions.Answers.length - 1].isNA">

                      <span *ngIf="questions.Answers[questions.Answers.length - 1].value_text == ''"
                        title="{{questions.Answers[questions.Answers.length - 1].weight}}">
                        {{questions.Answers[questions.Answers.length - 1].weight}} </span>
                      <span *ngIf="questions.Answers[0].value_text != ''">
                        {{questions.Answers[questions.Answers.length - 1].value_text}}</span>
                    </div>


                    <div class="rs-high-value fr" title="{{questions.Answers[questions.Answers.length - 2].value_text}}"
                      *ngIf="questions.Answers[questions.Answers.length - 1].isNA">
                      <span *ngIf="questions.Answers[questions.Answers.length - 2].value_text == ''"
                        title="{{questions.Answers[questions.Answers.length - 2].weight}}">
                        {{questions.Answers[questions.Answers.length - 2].weight}} </span>
                      <span *ngIf="questions.Answers[0].value_text != ''">
                        {{questions.Answers[questions.Answers.length - 2].value_text}}</span>
                    </div>
                  </div>
                </div>

                <div class="clearfix sl_wrapper" style="cursor: pointer;"
                  (keydown.space)="clearMobileRatingScale($event)" (click)="clearMobileRatingScale($event)">
                  <div class="rs-clear-cont inline_Btn">
                    <div class="rs-clear-text-cont">
                      <span class="rs-clear-text" (keydown.space)="clearMobileRatingScale($event)"
                        (click)="clearMobileRatingScale($event)">{{clearText}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <ng-template #smileyTextpopulation>
                <span class="answer-text">{{GetQuestionPrePopValue()}}</span>
              </ng-template>
            </div>

            <!-- New Approch To Participation Button -->
            <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
              <div class="ques-response-btn-div" *ngIf="showNewParticipationButton">

                <button *ngIf="isAnsChange" type="button" class="ques-response-btn"
                  (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                  (click)="gotoNextQuestion(questions, $event.target)">
                  {{ newParticipationBtnText }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>